import { Observable, observe, Scope } from 'wdc-cube'

@Observable
export class SectionHeaderScope extends Scope {
    @observe() description = ''
}
